import * as React from 'react';
import styled, { css } from 'styled-components';

import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

interface IProps {
  /** @ignore */
  children?: React.ReactNode;
  /** 
   * Add padding to content? 
   * @default false
   */
  padded?: boolean;
  /** Height is a CSS string */
  height: string;
}

const Scroller = (props: IProps) =>
  <OverlayScrollbarsComponent defer options={{ scrollbars: { theme: 'os-theme-dark', autoHide: 'leave' }}} style={{
    height: props.height,
    overflowY: 'auto'
  }}>
    <Padding $padded={props.padded ?? false}>
      {props.children}
    </Padding>
  </OverlayScrollbarsComponent>  

const Padding = styled.div<{ $padded: boolean }>`
  ${p => p.$padded == true && css`
    padding: 8px 20px 8px 16px;
  `}
`

export { Scroller }
